export const filterCollectionByFilterName = (
  filterName,
  collection = [],
  filters
) => {
  return collection.filter((item) =>
    filters[filterName]
      ? filters[filterName]?.some(
          (selectedFilter) => item.id === selectedFilter.id
        )
      : true
  );
};

export const getHiddenCompanies = (collection = [], categoryIdx) => {
  return collection.reduce((prev, curr, companyIdx) => {
    if (curr.isShowed === false) {
      prev.push({
        key: curr.id,
        label: curr.label,
        companyIdx,
        categoryIdx,
      });
    }
    return prev;
  }, []);
};

export const getHiddenBrands = (collection = [], categoryIdx, companyIdx) => {
  return collection.reduce((prev, curr, brandIdx) => {
    if (curr.isShowed === false) {
      prev.push({
        key: curr.id,
        label: curr.label,
        companyIdx,
        categoryIdx,
        brandIdx,
      });
    }
    return prev;
  }, []);
};
